<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Zusatzinformationen</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getFurtherInformationItems" :key="index">
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle
                                        </v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                    <div class="d-flex pa-3 mt-4 mx-5 document-container">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" download>Zertifikate</a>
                    </div>

                    <div class="d-flex pa-3 mt-4 mx-5 document-container">
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" download>Prufbereichte</a>
                    </div>

                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{$t('zusatzinformationen')}}</h2>
                        <p class="ma-0 menu-description">{{$t('zusatzinformationenDescription')}}</p>
                    </div>
                    <a href="javascript:void(0)"  class="resources-holder" v-if="showResources">
                        <div @click="toggleResources = !toggleResources" class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                <p class="font-weight-bold menu-title"><span>{{docNumber + charDocNumber}}</span> {{$t('documentsLabel')}}</p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                    <p class="font-weight-bold menu-title"><span>{{docNumber + charDocNumber}}</span> {{$t('documentsLabel')}}</p>
                                </div>
                                <div class="resources-content">
                                    <v-expansion-panels focusable class="mb-4">
                                        <v-expansion-panel v-for="(d, index) in docs" :key="index">
                                            <v-expansion-panel-header>{{$t(d.label)}}</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div v-for="(r, index) in d.resources" :key="index" class="d-flex pa-3 my-4 document-container">
                                                    <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <a v-bind="attrs" v-on="on" class="black--text" target="_blank" :href="r.resourceLocation" download>
                                                                {{r.text.length > 15 ? r.text.substring(0,15) + '...' : r.text}}
                                                            </a>
                                                        </template>
                                                        <span>{{r.text}}</span>
                                                    </v-tooltip>
                                                </div>  
                                                
                                                <div v-if="Object.keys(d.resources).length === 0" class="d-flex pa-3 my-4 document-container">{{$t('noDocLabel')}}</div>                                   
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                        <v-expansion-panel v-for="(d, index) in charDocs" :key="index">
                                            <v-expansion-panel-header>{{$t(d.label)}}</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div v-for="(r, index) in d.resources" :key="index" class="d-flex pa-3 my-4 document-container">
                                                    <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <a v-bind="attrs" v-on="on" class="black--text" target="_blank" :href="r.resourceLocation" download>
                                                                {{r.title.length > 15 ? r.title.substring(0,15) + '...' : r.title}}
                                                            </a>
                                                        </template>
                                                        <span>{{r.title}}</span>
                                                    </v-tooltip>
                                                </div>  
                                                
                                                <div v-if="Object.keys(d.resources).length === 0" class="d-flex pa-3 my-4 document-container">{{$t('noDocLabel')}}</div>                                   
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>
                            </div>
                        </transition>
                    </a>
                </div>
            </div>
            <v-divider></v-divider>
            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                    <Accessories></Accessories>
                    <v-divider class="my-4"></v-divider>
                    <v-form
                        ref="furtherInfoForm"
                        v-model="valid"
                        lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    v-model="incoterm"
                                    dense
                                    item-text="incotermText"
                                    class=""
                                    item-value="incotermCode"
                                    :items="incoterms"
                                    :label="$t('incotermsLabel')"
                                    outlined
                                    @change="checkDeliveryAddress"
                                    return-object
                                    :rules="incotermRules"
                                    required
                                >
                                </v-select>
                                <div class="body-2 mt-n4 mb-3 violet-text" v-if="showIncotermNotes">
                                    {{$t('incotermNoteDescription')}}
                                </div>
                                <v-textarea
                                        v-if="hasDeliveryAddress"
                                        :rules="[deliveryAddressRule.maxValue(deliveryAddress,parseInt(30),$t('requiredValueLabel'), $t('maximumAllowedCharacterIs'))]"
                                        dense
                                        rows="3"
                                        :counter="30"
                                        v-model="deliveryAddress"
                                        outlined
                                        :label="$t('lieferadresseFurIncotermsLabel')"
                                        class="body-2"
                                        required
                                >
                                </v-textarea>
        <!--                        <v-text-field v-if="hasDeliveryAddress" hide-details outlined dense class="body-2 mt-6" label="Enter the delivery address for the selected incoterm" v-model="deliveryAddress"></v-text-field>-->
                            </v-col>

                            <v-col sm="12" md="6" v-if="isCFR">
                                <v-select
                                    v-model="land"
                                    dense
                                    item-text="Name"
                                    class=""
                                    item-value="Value"
                                    :items="lands"
                                    :label="$t('landLabel')"
                                    outlined
                                    required
                                    :rules="landRules"
                                    :no-data-text="$t('noDataAvailable')"
                                >
                                </v-select>
                            </v-col>

                            <v-col sm="12" md="6" v-if="isCFR">
                                <v-select
                                    v-model="zone"
                                    dense
                                    item-text="plz"
                                    class=""
                                    item-value="id"
                                    :items="zones"
                                    :label="$t('zoneLabel')"
                                    outlined
                                    required
                                    :rules="zoneRules"
                                    :no-data-text="$t('noDataAvailable')"
                                >
                                </v-select>
                            </v-col>

                            <v-col sm="12" md="6">
                                <v-select
                                v-model="paymentTerm"
                                dense
                                item-text="paymentTermText" class="mt-n5"
                                item-value="paymentTermCode"
                                :items="paymentTerms"
                                :label="$t('paymentTermsLabel')"
                                outlined
                                return-object
                                :rules="paymentTermRules"
                                required
                                >
                                </v-select>
                            </v-col>

                            <v-col sm="12" md="6">
                                <v-text-field v-model="purchNoC" :rules="purchNoRules" dense class="mt-n5" :label="$t('bestellnummerLabel')" outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mb-2 mt-n5">
                            <v-col sm="12" md="6">
                                <v-text-field v-model="textLineK" dense hide-details class="m2-8" :label="$t('kontaktPerson')" outlined></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6">
                                <v-text-field v-model="textLineL" dense hide-details class="m2-8" :label="$t('lieferadresse')" outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mb-2">
                            <v-col sm="12" md="12">
                                <v-text-field v-model="textLineLD" dense hide-details class="m2-8" :label="$t('lieferdatumInformation')" outlined></v-text-field>
                            </v-col>
                            <v-col sm="12" md="12">
                                <v-textarea
                                        hide-details
                                        dense
                                        v-model="textLineA"
                                        rows="3"
                                        class="m2-8"
                                        outlined
                                        :label="$t('anhang')"
                                >

                                </v-textarea>
        <!--                        <v-text-field v-model="textLineA" dense hide-details class="m2-8" :label="$t('anhang')" outlined></v-text-field>-->
                            </v-col>
                        </v-row>

                        <GetProductPrice :form="$refs" :isValid="valid" :lands="lands" />
                    </v-form>
                </simplebar>
            </v-card>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFunctions />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFrame />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RMeasures />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RDoorLeafSurface />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RExteriorAccessory />
                            </v-expansion-panels>
                             <v-expansion-panels flat accordion>
                                <RBlindstockMultiplex />
                            </v-expansion-panels>
                             <v-expansion-panels flat accordion>
                                <RFurtherInformation />
                            </v-expansion-panels>
                        </div>
                        <div class="d-flex flex-column pa-4">
                            
<!--                            <v-btn depressed color="green mb-2" dark @click="saveAndGenerateJsonData()"> Get Json Data </v-btn>-->
<!--                        -->
<!--                            <v-btn v-if="jsonBase64File"-->
<!--                             depressed color="green" dark -->
<!--                             download="ProductConfiguration.json"-->
<!--                            :href="jsonBase64File"-->
<!--                            @click="jsonBase64File = ''" -->
<!--                            >Download</v-btn>-->
                            
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
    <!-- <div class="content-wrapper tab-pane fade" id="further-info" role="tabpanel" aria-labelledby="further-info-tab"> -->

</template>
<script>
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'

    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        MainNavigationFilter
    } from '../../configurator/MainNavigation';
    import {
        NavigationFilter,
        modelSelectionNavigationItemsInit
    } from '../../configurator/ModelSelectionNavigationItems';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue,
        DependenciesFilter
    } from '../../configurator/types';

    import resourcesService from '../../services/Configurator/ResourcesService';
    import ModelsFound from './components/ModelsFound.vue';
    import RModelSelection from './components/RModelSelection.vue';
    import RFunctions from './components/RFunctions.vue';
    import RFrame from './components/RFrame.vue';
    import RMeasures from './components/RMeasures.vue';
    import RDoorLeafSurface from './components/RDoorLeafSurface.vue';
    import RExteriorAccessory from './components/RExteriorAccessory.vue';
    import RMountingMaterial from './components/RMountingMaterial.vue';
    import RBlindstockMultiplex from './components/RBlindstockMultiplex.vue';
    import RFurtherInformation from './components/RFurtherInformation.vue';

    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    import GetProductPrice from './components/GetProductPrice';
    import nProgress from 'nprogress';

    import productConfigurationService from '../../services/Configurator/ProductConfigurationService';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    import UserTypes from "../../auth/userTypes";
    import Accessories from "@/views/productConfigurator/components/Accessories";

    export default Vue.extend({
        name: 'FurtherInformation',
        components: {
            Accessories,
            simplebar,
            RModelSelection,
            RFunctions,
            RFrame,
            RMeasures,
            RDoorLeafSurface,
            RExteriorAccessory,
            RMountingMaterial,
            RBlindstockMultiplex,
            RFurtherInformation,
            ModelsFound,
            SaveCurrentConfiguration,
            GetProductPrice
        },
        data() {
            return {
                valid: true,
                showResources: true,
                toggleResources: false,
                hasDeliveryAddress: false,
                isCFR: false,
                additionalInfo: '',
                showModal: false,
                showSettingsContent: 1,
                active: 0,
                windowMainNavId: 9,
                readyForOrder: false,
                incoterms: [],
                paymentTerms: [],
                settignsItems: [],
                lands: [
                    {
                        Value: 'DE',
                        Name: 'DEUTSCHLAND'
                    },
                    {
                        Value: 'CH',
                        Name: 'SCHWEIZ'
                    },
                    {
                        Value: 'AT',
                        Name: 'ÖSTERREICH'
                    }
                ],
                zones: [],
                zonesList: [
                    {
                        land: 'DE',
                        zone: [
                            {
                                id: 1,
                                plz: '80 - 81'
                            },
                            {
                                id: 2,
                                plz: '82 - 86'
                            },
                            {
                                id: 3,
                                plz: '87, 89 - 94'
                            },
                            {
                                id: 4,
                                plz: '70 - 76, 78, 88, 95 - 97'
                            },
                            {
                                id: 5,
                                plz: '07 - 09, 36, 63 - 64, 67 - 69, 77, 79, 98, 99'
                            },
                            {
                                id: 6,
                                plz: '01, 04, 06, 34 - 35, 55, 60 - 61, 65 - 66'
                            },
                            {
                                id: 7,
                                plz: '02 - 03, 14, 33, 37 - 39, 50 - 51, 53  - 54, 56 - 59'
                            },
                            {
                                id: 8,
                                plz: '10 - 13, 15 - 16, 29 - 32, 40 - 49, 52'
                            },
                            {
                                id: 9,
                                plz: '17, 19 - 22, 27 - 28'
                            },
                            {
                                id: 10,
                                plz: '18, 23 - 26'
                            },
                        ]
                    },
                    {
                        land: 'CH',
                        zone: [
                            {
                                id: 6,
                                plz: '82, 90 - 96 '
                            },
                            {
                                id: 9,
                                plz: '40-41, 80'
                            },
                            {
                                id: 10,
                                plz: '42 - 44, 46 - 48, 50 - 57, 63, 81, 83 - 89'
                            },
                            {
                                id: 11,
                                plz: '25 - 30, 32 - 34, 45, 49, 60 - 62'
                            },
                            {
                                id: 12,
                                plz: '15 - 17, 20 - 24, 31, 35 - 36, 64'
                            },
                            {
                                id: 13,
                                plz: '10, 13 - 14, 18, 37 - 38, 65, 67, 70 - 77'
                            },
                            {
                                id: 15,
                                plz: '11 - 12, 19, 39, 66, 68 - 69'
                            }
                        ]
                    },
                    {
                        land: 'AT',
                        zone: [
                            {
                                id: 1,
                                plz: '50 - 59'
                            },
                            {
                                id: 2,
                                plz: '32 - 33, 37 - 49'
                            },
                            {
                                id: 3,
                                plz: '60 - 69'
                            },
                            {
                                id: 4,
                                plz: '10 - 31, 34 - 36, 70 - 80'
                            },
                            {
                                id: 5,
                                plz: '90 - 99'
                            },
                        ]
                    }
                ],
                product: {},
                jsonBase64File: '',
                docNumber: 0,
                charDocNumber: 0,
                bodyCalcHeight: 0,
                docs:{
                    zertifikateDocs:{
                        label: 'zertifikate',
                        resources: []
                    },
                    prufberichteDocs: {
                        label: 'prufbereichte',
                        resources: []
                    },
                    ecbDocs:{
                        label: 'ecb',
                        resources: []
                    },
                },
                charDocs:{
                    vkfDocs:{
                        label: 'vkf',
                        resources: []
                    },
                    pflegeDocs:{
                        label: 'pflege',
                        resources: []
                    },
                    diverseDocs:{
                        label: 'diverse',
                        resources: []
                    },
                },
                zertifikateDoc:{},
                deliveryAddressRule: {
                    maxValue(value, max, requiredM, maximumIsM) {
                        if(!value)
                            return requiredM;
                        return (value.length || "") <= max || maximumIsM + ` ${max}`;
                    },
                },
                incotermRules:[
                    v => !!v || this.$t('requiredValueLabel')
                ],
                paymentTermRules:[
                    v => !!v || this.$t('requiredValueLabel')
                ],
                purchNoRules:[
                    v => !!v || this.$t('requiredValueLabel')
                ],
                landRules:[
                    v => !!v || this.$t('requiredValueLabel')
                ],
                zoneRules:[
                    v => !!v || this.$t('requiredValueLabel')
                ],
                showIncotermNotes: false,
                context: DoorConfiguration
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration', 'getMainNav','getFurtherInformationItems','getRegisteredCharacteristicsValue']),
            ...mapGetters('modelSelectionModule', ['getModelSelection']),
            ...mapGetters('measureModule', ['getDoorLeafSizes']),
            ...mapGetters('furtherInformationModule', ['getIncoterm', 'getDeliveryAddress', 'getPaymentTerm', 'getTextLineL', 'getTextLineLD', 'getTextLineA', 'getTextLineK', 'getPurchNoC', 'getLand', 'getZone']),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            },
            incoterm : {
                // getter
                get: function () {
                    this.showIncotermNotes = this.getIncoterm === 'Z+M'
                    return this.getIncoterm;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setIncoterm', newValue)
                }
            },

            deliveryAddress : {
                // getter
                get: function () {
                    return this.getDeliveryAddress;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setDeliveryAddress', newValue)
                }
            },

            land: {
                // getter
                get: function () {
                    return this.getLand;
                },
                // setter
                set: function (newValue) {
                    this.getAllZones(newValue)
                    this.zone = ''
                    this.$store.dispatch('furtherInformationModule/setLand', newValue)
                }
            },

            zone: {
                // getter
                get: function () {
                    return this.getZone;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setZone', newValue)
                }
            },

            paymentTerm : {
                // getter
                get: function () {
                    return this.getPaymentTerm;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setPaymentTerm', newValue)
                }
            },

            textLineL: {
                // getter
                get: function () {
                    return this.getTextLineL;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setTextLineL', newValue)
                }
            },

            textLineLD: {
                // getter
                get: function () {
                    return this.getTextLineLD;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setTextLineLD', newValue)
                }
            },

            textLineA: {
                // getter
                get: function () {
                    return this.getTextLineA;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setTextLineA', newValue)
                }
            },

            textLineK: {
                // getter
                get: function () {
                    return this.getTextLineK;
                },
                // setter
                set: function (newValue) {
                    this.$store.dispatch('furtherInformationModule/setTextLineK', newValue)
                }
            },

            purchNoC: {
                //getter
                get: function(){
                    return this.getPurchNoC;
                },
                //setter
                set: function(newValue){
                    this.$store.dispatch('furtherInformationModule/setPurchNoC', newValue);
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId'
            ]),
            ...mapActions('modelSelectionModule', ['setNavigationItems']),
            ...mapActions('configuratorModule', ['setProductId']),

            toggleModal(state) {
                this.showModal = state;
            },
            canEditPriceRequest() {
                this.axios.get("/api/user/me")
                    .then((response) => {
                        if(this.deliveryAddress === "") {
                            this.deliveryAddress = response.data.deliveryInformation
                        }
                    })
                    .catch(error => {console.log(error)})
            },
            settingsNavigation(index) {
                this.active = index;
                this.showSettingsContent = index;
            },
            getAllIncoterms()
            {
                var companyId = this.$store.state.user.companyId;
                this.axios.get('api/company/getCompanyIncoterms',{
                    params: {
                        companyId: companyId
                    }
                }).then(response => {
                    this.incoterms = response.data;
                    let selectedIncoterm = this.incoterms.find(x => x.incotermCode === this.incoterm);
                    if(typeof selectedIncoterm !== 'undefined') {
                        if(selectedIncoterm.incotermDeliveryAddressMandatory){
                            this.hasDeliveryAddress = true;
                        }else {
                            this.hasDeliveryAddress = false;
                            this.deliveryAddress = "";
                        }
                        if(selectedIncoterm.incotermCode === "CFR"){
                            this.$store.dispatch('furtherInformationModule/setFreight', '200')
                            this.isCFR = true
                        }
                        else{
                            this.$store.dispatch('furtherInformationModule/setFreight', '')
                            this.isCFR = false
                        }
                    }else {
                        this.hasDeliveryAddress = false;
                        this.deliveryAddress = "";
                        this.isCFR = false;
                        this.land = '';
                        this.zone = '';
                        this.$store.dispatch('furtherInformationModule/setFreight', '')
                    }
                });


            },
            getAllPaymentTerms(){
                var companyId = this.$store.state.user.companyId;
                this.axios.get('api/company/getCompanyPaymentTerms',{
                    params: {
                        companyId: companyId
                    }
                }).then(response => {
                    this.paymentTerms = response.data;
                });
            },


            getSettingsItemsFromStore() {

                var setting = this.$store.state.mainMenu.filter((task) => task.id === 9);
                var settingObject = setting[0];

                this.settignsItems = settingObject.characteristicsItems;
            },
            resetModelSelection() {
                // this.doorConfiguration = this.getCurrentDoorConfiguration;
                // this.doorConfiguration.ClearConfiguration(DoorConfiguration.FurtherInformation);
                // this.$store.dispatch('updateDoorConfiguration', this.doorConfiguration);

                // // this.updateNavigation();
                // let mainNav = new MainNavigationFilter(this.getMainNav);
                // let mainNavItems = mainNav.ResetMainNavigationItemStatus(this.windowMainNavId, false);
                // this.setMainNavigationItems(mainNavItems);



                this.doorConfiguration = this.getCurrentDoorConfiguration;

                this.doorConfiguration.ClearAllConfiguration();

                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);

                // console.log(modelSelectionNavigationItemsInit);


                // let objModelSelectionNavigationItemsInit = modelSelectionNavigationItemsInit.slice(0);
                let objModelSelectionNavigationItemsInit = JSON.parse(JSON.stringify(
                    modelSelectionNavigationItemsInit));

                this.setNavigationItems(objModelSelectionNavigationItemsInit);

                // console.log(objModelSelectionNavigationItemsInit);
                let objMainNavigationItemsInit = JSON.parse(JSON.stringify(mainNavigationItemsInit));

                let mainNav = new MainNavigationFilter(objMainNavigationItemsInit);
                let mainNavItems = mainNav.UpdateMainNavigation(objModelSelectionNavigationItemsInit, 1, false,
                    true);
                this.setMainNavigationItems(mainNavItems);


                this.$router.push('/model-selection');
                this.setMainNavActiveId(1);
            },
            // saveAndGenerateJsonData()
            // {
            //     productConfigurationService.saveCurrentProductConfigurator(this.getCurrentDoorConfiguration).then(( response ) => {
            //       if(response.data !== ""){
            //           this.setProductId(response.data.id);
            //           this.$store.dispatch('storeCurrentProduct',response.data);
            //           this.generateJsonData(response.data.id);
            //       }
            //     });
            //
            // },
            //
            // generateJsonData(productId)
            // {
            //     this.axios.get('/api/productconfiguration/getProductJsonData', {
            //         params: {
            //             productId: productId
            //         }
            //     }).then(response => {
            //         var data = atob(response.data);
            //             var fileURL = window.URL.createObjectURL(new Blob([data]))
            //             this.jsonBase64File = fileURL;
            //         }).catch(error => {
            //
            //         });
            // },

            checkDeliveryAddress(data){
                if(typeof data !== 'undefined') {
                    if(data.incotermDeliveryAddressMandatory){
                        this.hasDeliveryAddress = true;
                        this.canEditPriceRequest()
                    }else {
                        this.hasDeliveryAddress = false;
                        this.deliveryAddress = "";
                    }

                    this.land = ''
                    this.zone = ''
                    if(data.incotermCode === "CFR"){
                        this.$store.dispatch('furtherInformationModule/setFreight', '200')
                        this.isCFR = true
                    }
                    else{
                        this.$store.dispatch('furtherInformationModule/setFreight', '')
                        this.isCFR = false
                    }
                }else {
                    this.hasDeliveryAddress = false;
                    this.deliveryAddress = "";
                    this.isCFR = false
                    this.land = ''
                    this.zone = ''
                    this.$store.dispatch('furtherInformationModule/setFreight', '')
                }

            },
            charValDocResources: function(filter, code){
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    if(result.data.length > 0){
                        if(code === 'CUST_MM_ZERTIFIKATE')
                            _this.docs.zertifikateDocs.resources.push(result.data[0]);
                        else if(code === 'CUST_MM_PRUFBERICHTE')
                            _this.docs.prufberichteDocs.resources.push(result.data[0]);
                        else if(code === 'CUST_MM_ECB')
                            _this.docs.ecbDocs.resources.push(result.data[0]);

                        //calculate number of docs
                        _this.docNumberHandler();
                    }

                })
            },
            charDocResources: function(filter){
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode(filter);

                resource.then(function (result) {
                    if(result.data.length > 0){
                        if(filter === 'CUST_MM_VKFANERKENNUNG')
                            _this.charDocs.vkfDocs.resources = result.data;
                        else if(filter === 'CUST_MM_PFLEGEWARTUNG')
                            _this.charDocs.pflegeDocs.resources = result.data;
                        else if(filter === 'CUST_MM_DIVERSETECHNISCHE')
                            _this.charDocs.diverseDocs.resources = result.data;
                        _this.charDocNumberHandler();
                    }
                })
            },
            docResourcesMounted: function(){
                const _this = this;

                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'CUST_MM_ZERTIFIKATE', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === false) {
                    this.charValDocResources(filter.dependenciesStr, 'CUST_MM_ZERTIFIKATE');
                }

                const filter1 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'CUST_MM_PRUFBERICHTE', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === false) {
                    this.charValDocResources(filter1.dependenciesStr, 'CUST_MM_PRUFBERICHTE');
                }

                const filter2 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'CUST_MM_ECB', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === false) {
                    this.charValDocResources(filter2.dependenciesStr, 'CUST_MM_ECB');
                }

                //CUST_MM_VKFANERKENNUNG
                this.charDocResources('CUST_MM_VKFANERKENNUNG');
                //CUST_MM_PFLEGEWARTUNG
                this.charDocResources('CUST_MM_PFLEGEWARTUNG');
                //CUST_MM_DIVERSETECHNISCHE
                this.charDocResources('CUST_MM_DIVERSETECHNISCHE');
            },
            docNumberHandler(){
                const l = Object.values(this.docs).reduce( (a, e) => a + e.resources.length, 0);
                this.docNumber = l;
            },
            charDocNumberHandler(){
                const l = Object.values(this.charDocs).reduce( (a, e) => a + e.resources.length, 0);
                this.charDocNumber = l;
            },
            recalcBodyHeight(){
                //calculation of top-bar height
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight + 1;
            },
            getAllZones(val){
                if (typeof val !== 'undefined' && val !== '')
                    this.zones = this.zonesList.find(f => f.land === val).zone
                else
                    this.zones = []
            },
            isDoorCertified: function () {
                let itemNumber = this.getRegisteredCharacteristicsValue('KTU_MM_ARTIKELNR', this.context.ModelSelection).value.value;

                let doorLeafSizes = this.getDoorLeafSizes.find(x => x.itemNumber === itemNumber);
                if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_STLB', this.context.Measure).value.value, doorLeafSizes.minSTLB)){
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else if(!this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_STLB', this.context.Measure).value.value, doorLeafSizes.maxSTLB)) {
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_BSTLH', this.context.Measure).value.value, doorLeafSizes.minSTLH)) {
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else if(!this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_BSTLH', this.context.Measure).value.value, doorLeafSizes.maxSTLH + doorLeafSizes.maxUpperPanelHeight)) {
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else if(!this.minValue(this.getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', this.context.Measure).value.value, doorLeafSizes.minSTLH)) {
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else if(!this.maxValue(this.getRegisteredCharacteristicsValue('KTU_MM_GBSTLH', this.context.Measure).value.value, doorLeafSizes.maxSTLH + doorLeafSizes.maxUpperPanelHeight)){
                    this.textLineA = this.$t('doorIsNotCertified')
                }
                else{
                    this.textLineA = ''
                }
            },
            minValue(value,min) {
                return (value || "") >= min || false;
            },
            maxValue(value,max) {
                return (value || "") <= max || false;
            },
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            this.getAllIncoterms();
            this.getAllPaymentTerms();
            this.docResourcesMounted();
            this.canEditPriceRequest();
            this.getAllZones(this.getLand)
            //calculation of top-bar height
            this.bodyCalcHeight = this.$refs.topBar.clientHeight + 1;
            if (this.textLineA === '')
                this.isDoorCertified()
        },
    });
</script>
<style lang="scss" scoped>
.main-row-fill-height{
    height: 100%;
    margin-left: 0;
    margin-right: 0;
    >.col{
        max-height: 100%;
    }
}
.violet-text{
  color: #65006c !important;
}
</style>